// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400&family=Inter:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  overflow: hidden;
  background: #000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* ========================================
   LUXURY DIAMOND SCROLLBAR
   ======================================== */

/* Webkit Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(
    45deg,
    rgba(212, 175, 55, 0.8) 0%,
    rgba(244, 228, 166, 1) 25%,
    rgba(255, 215, 0, 0.9) 50%,
    rgba(244, 228, 166, 1) 75%,
    rgba(212, 175, 55, 0.8) 100%
  );
  border-radius: 4px;
  box-shadow:
    0 0 10px rgba(212, 175, 55, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  position: relative;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(
    45deg,
    rgba(212, 175, 55, 0.9) 0%,
    rgba(244, 228, 166, 1) 25%,
    rgba(255, 215, 0, 1) 50%,
    rgba(244, 228, 166, 1) 75%,
    rgba(212, 175, 55, 0.9) 100%
  );
  box-shadow:
    0 0 15px rgba(212, 175, 55, 0.6),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

::-webkit-scrollbar-thumb:active {
  background: linear-gradient(
    45deg,
    rgba(212, 175, 55, 1) 0%,
    rgba(255, 215, 0, 1) 50%,
    rgba(212, 175, 55, 1) 100%
  );
  box-shadow:
    0 0 20px rgba(212, 175, 55, 0.8),
    inset 0 2px 4px rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar-corner {
  background: rgba(0, 0, 0, 0.8);
}

/* Firefox Scrollbar */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(212, 175, 55, 0.8) rgba(0, 0, 0, 0.8);
}

/* Custom Scrollbar Animation */
@keyframes scrollbarGlow {
  0%, 100% {
    box-shadow:
      0 0 10px rgba(212, 175, 55, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
  }
  50% {
    box-shadow:
      0 0 20px rgba(212, 175, 55, 0.6),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
  }
}

.seacat-real {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
}

/* Loading */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-content {
  text-align: center;
  color: #fff;
}

.loading-content h2 {
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin-bottom: 30px;
  opacity: 0.8;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-top-color: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Simple Progress Dots */
.simple-progress {
  position: fixed;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 16px;
  z-index: 100;
}

.simple-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.simple-dot.pending {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.simple-dot.completed {
  background: rgba(212, 175, 55, 0.6);
  border: 1px solid rgba(212, 175, 55, 0.4);
}

.simple-dot.active-normal {
  background: rgba(212, 175, 55, 0.9);
  border: 1px solid rgba(212, 175, 55, 1);
  box-shadow: 0 0 8px rgba(212, 175, 55, 0.4);
}

.simple-dot.active-reverse {
  background: rgba(255, 107, 107, 0.9);
  border: 1px solid rgba(255, 107, 107, 1);
  box-shadow: 0 0 8px rgba(255, 107, 107, 0.4);
}

/* Status Indicator */
.status-indicator {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  z-index: 100;
}

.status-indicator .playing {
  color: rgba(255, 255, 255, 0.8);
  animation: pulse 1s ease-in-out infinite;
}

.status-indicator .ready {
  color: rgba(255, 255, 255, 0.4);
}

@keyframes pulse {
  0%, 100% { opacity: 0.8; }
  50% { opacity: 1; }
}

/* Video Label */
.video-label {
  position: fixed;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255, 255, 255, 0.8);
  font-size: 24px;
  font-weight: 200;
  letter-spacing: 0.1em;
  z-index: 100;
}

/* ========================================
   DIAMOND VISION LUXURY TEXT OVERLAY
   ======================================== */

.diamond-vision-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 200;
  overflow: hidden;
}

.vision-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  transition: all 1.2s cubic-bezier(0.165, 0.84, 0.44, 1);
  opacity: 0;
  pointer-events: none;
}

.vision-text.visible {
  opacity: 1;
  animation: textReveal 1.5s cubic-bezier(0.165, 0.84, 0.44, 1);
}

.vision-text.hidden {
  opacity: 0;
  transform: translate(-50%, -45%);
}

.text-stage {
  max-width: 800px;
  padding: 0 40px;
  animation: stageEntry 1.8s cubic-bezier(0.19, 1, 0.22, 1);
}

/* Primary Headlines */
.primary-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2.5rem, 5vw, 4.5rem);
  font-weight: 500;
  color: #ffffff;
  line-height: 1.1;
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
  animation: primarySlide 1.6s cubic-bezier(0.19, 1, 0.22, 1) 0.3s both;
}

/* Secondary Headlines */
.secondary-text {
  font-family: 'Playfair Display', serif;
  font-size: clamp(1.8rem, 3.5vw, 3rem);
  font-weight: 400;
  font-style: italic;
  color: #d4af37;
  line-height: 1.2;
  margin-bottom: 2rem;
  letter-spacing: 0.01em;
  text-shadow: 0 2px 15px rgba(212, 175, 55, 0.4);
  animation: secondarySlide 1.6s cubic-bezier(0.19, 1, 0.22, 1) 0.6s both;
}

/* Elegant accent line */
.accent-line {
  width: 120px;
  height: 2px;
  background: linear-gradient(90deg,
    transparent 0%,
    #d4af37 20%,
    #f4e4a6 50%,
    #d4af37 80%,
    transparent 100%
  );
  margin: 0 auto 2rem;
  position: relative;
  animation: lineExpand 2s cubic-bezier(0.19, 1, 0.22, 1) 0.9s both;
}

.accent-line::before {
  content: '';
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 4px;
  height: 4px;
  background: #f4e4a6;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(244, 228, 166, 0.8);
}

/* Subtitle text */
.subtitle {
  font-family: 'Inter', sans-serif;
  font-size: clamp(0.9rem, 1.5vw, 1.1rem);
  font-weight: 300;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-bottom: 1rem;
  animation: subtitleFade 1.6s cubic-bezier(0.19, 1, 0.22, 1) 1.2s both;
}

/* Call to Action for final stage */
.vision-cta {
  margin-top: 3rem;
  position: relative;
  animation: ctaReveal 2s cubic-bezier(0.19, 1, 0.22, 1) 1.5s both;
}

.cta-text {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  color: #d4af37;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  display: inline-block;
  padding: 12px 24px;
  border: 1px solid rgba(212, 175, 55, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.cta-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
    transparent,
    rgba(212, 175, 55, 0.1),
    transparent
  );
  animation: shimmer 3s ease-in-out infinite 2s;
}

.diamond-sparkle {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #f4e4a6;
  transform: rotate(45deg);
  animation: sparkle 2s ease-in-out infinite;
}

/* Floating Particles System */
.diamond-particles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  overflow: hidden;
}

.particle {
  position: absolute;
  width: 3px;
  height: 3px;
  background: radial-gradient(circle, #f4e4a6 0%, transparent 70%);
  border-radius: 50%;
  opacity: 0;
  left: var(--x);
  top: var(--y);
  animation: particleFloat var(--duration) ease-in-out infinite var(--delay);
}

/* ========================================
   LUXURY ANIMATIONS
   ======================================== */

@keyframes textReveal {
  from {
    opacity: 0;
    transform: translate(-50%, -40%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes stageEntry {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes primarySlide {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes secondarySlide {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes lineExpand {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 120px;
    opacity: 1;
  }
}

@keyframes subtitleFade {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 0.8;
    transform: translateY(0);
  }
}

@keyframes ctaReveal {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

@keyframes sparkle {
  0%, 100% {
    opacity: 0.3;
    transform: rotate(45deg) scale(1);
  }
  50% {
    opacity: 1;
    transform: rotate(45deg) scale(1.2);
  }
}

@keyframes particleFloat {
  0% {
    opacity: 0;
    transform: translateY(0px) scale(0.5);
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-100px) scale(1);
  }
}



/* ========================================
   RESPONSIVE LUXURY DESIGN
   ======================================== */

@media (max-width: 768px) {
  .text-stage {
    padding: 0 20px;
  }

  .primary-text {
    font-size: clamp(1.8rem, 6vw, 3rem);
  }

  .secondary-text {
    font-size: clamp(1.2rem, 4vw, 2rem);
  }

  .subtitle {
    font-size: clamp(0.7rem, 2vw, 0.9rem);
  }

  .accent-line {
    width: 80px;
  }

  .vision-cta {
    margin-top: 2rem;
  }

  .cta-text {
    font-size: 0.7rem;
    padding: 10px 20px;
  }
}

@media (max-width: 480px) {
  .vision-text {
    padding: 0 16px;
  }

  .text-stage {
    padding: 0 16px;
  }

  .primary-text {
    line-height: 1.2;
    margin-bottom: 0.8rem;
  }

  .secondary-text {
    margin-bottom: 1.5rem;
  }

  .accent-line {
    width: 60px;
    margin-bottom: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/SeaCatReal/SeaCatReal.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAIA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+EAA+E;AACjF;;AAEA;;6CAE6C;;AAE7C,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE;;;;;;;GAOC;EACD,kBAAkB;EAClB;;0CAEwC;EACxC,kBAAkB;AACpB;;AAEA;EACE;;;;;;;GAOC;EACD;;0CAEwC;AAC1C;;AAEA;EACE;;;;;GAKC;EACD;;sCAEoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA,+BAA+B;AAC/B;EACE;IACE;;4CAEwC;EAC1C;EACA;IACE;;4CAEwC;EAC1C;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;6CAE6C;;AAE7C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,uDAAuD;EACvD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yDAAyD;AAC3D;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,0CAA0C;EAC1C,qEAAqE;AACvE;;AAEA,wBAAwB;AACxB;EACE,sCAAsC;EACtC,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,+CAA+C;EAC/C,uEAAuE;AACzE;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,WAAW;EACX;;;;;;GAMC;EACD,mBAAmB;EACnB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,uCAAuC;EACvC,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,qEAAqE;AACvE;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;GAIC;EACD,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gEAAgE;EAChE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,0EAA0E;AAC5E;;AAEA;;6CAE6C;;AAE7C;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,sCAAsC;EACxC;AACF;;;;AAIA;;6CAE6C;;AAE7C;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400&family=Inter:wght@300;400;500&display=swap');\n\nhtml, body {\n  overflow: hidden;\n  background: #000;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* ========================================\n   LUXURY DIAMOND SCROLLBAR\n   ======================================== */\n\n/* Webkit Scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.8);\n  border-radius: 4px;\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n::-webkit-scrollbar-thumb {\n  background: linear-gradient(\n    45deg,\n    rgba(212, 175, 55, 0.8) 0%,\n    rgba(244, 228, 166, 1) 25%,\n    rgba(255, 215, 0, 0.9) 50%,\n    rgba(244, 228, 166, 1) 75%,\n    rgba(212, 175, 55, 0.8) 100%\n  );\n  border-radius: 4px;\n  box-shadow:\n    0 0 10px rgba(212, 175, 55, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  position: relative;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(\n    45deg,\n    rgba(212, 175, 55, 0.9) 0%,\n    rgba(244, 228, 166, 1) 25%,\n    rgba(255, 215, 0, 1) 50%,\n    rgba(244, 228, 166, 1) 75%,\n    rgba(212, 175, 55, 0.9) 100%\n  );\n  box-shadow:\n    0 0 15px rgba(212, 175, 55, 0.6),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n::-webkit-scrollbar-thumb:active {\n  background: linear-gradient(\n    45deg,\n    rgba(212, 175, 55, 1) 0%,\n    rgba(255, 215, 0, 1) 50%,\n    rgba(212, 175, 55, 1) 100%\n  );\n  box-shadow:\n    0 0 20px rgba(212, 175, 55, 0.8),\n    inset 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n::-webkit-scrollbar-corner {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n/* Firefox Scrollbar */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(212, 175, 55, 0.8) rgba(0, 0, 0, 0.8);\n}\n\n/* Custom Scrollbar Animation */\n@keyframes scrollbarGlow {\n  0%, 100% {\n    box-shadow:\n      0 0 10px rgba(212, 175, 55, 0.4),\n      inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    box-shadow:\n      0 0 20px rgba(212, 175, 55, 0.6),\n      inset 0 1px 0 rgba(255, 255, 255, 0.4);\n  }\n}\n\n.seacat-real {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #000;\n}\n\n/* Loading */\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.loading-content {\n  text-align: center;\n  color: #fff;\n}\n\n.loading-content h2 {\n  font-size: 20px;\n  font-weight: 300;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  margin-bottom: 30px;\n  opacity: 0.8;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-top-color: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Simple Progress Dots */\n.simple-progress {\n  position: fixed;\n  right: 30px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  z-index: 100;\n}\n\n.simple-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.simple-dot.pending {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.simple-dot.completed {\n  background: rgba(212, 175, 55, 0.6);\n  border: 1px solid rgba(212, 175, 55, 0.4);\n}\n\n.simple-dot.active-normal {\n  background: rgba(212, 175, 55, 0.9);\n  border: 1px solid rgba(212, 175, 55, 1);\n  box-shadow: 0 0 8px rgba(212, 175, 55, 0.4);\n}\n\n.simple-dot.active-reverse {\n  background: rgba(255, 107, 107, 0.9);\n  border: 1px solid rgba(255, 107, 107, 1);\n  box-shadow: 0 0 8px rgba(255, 107, 107, 0.4);\n}\n\n/* Status Indicator */\n.status-indicator {\n  position: fixed;\n  bottom: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 12px;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  z-index: 100;\n}\n\n.status-indicator .playing {\n  color: rgba(255, 255, 255, 0.8);\n  animation: pulse 1s ease-in-out infinite;\n}\n\n.status-indicator .ready {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 0.8; }\n  50% { opacity: 1; }\n}\n\n/* Video Label */\n.video-label {\n  position: fixed;\n  top: 40px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 24px;\n  font-weight: 200;\n  letter-spacing: 0.1em;\n  z-index: 100;\n}\n\n/* ========================================\n   DIAMOND VISION LUXURY TEXT OVERLAY\n   ======================================== */\n\n.diamond-vision-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  pointer-events: none;\n  z-index: 200;\n  overflow: hidden;\n}\n\n.vision-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  transition: all 1.2s cubic-bezier(0.165, 0.84, 0.44, 1);\n  opacity: 0;\n  pointer-events: none;\n}\n\n.vision-text.visible {\n  opacity: 1;\n  animation: textReveal 1.5s cubic-bezier(0.165, 0.84, 0.44, 1);\n}\n\n.vision-text.hidden {\n  opacity: 0;\n  transform: translate(-50%, -45%);\n}\n\n.text-stage {\n  max-width: 800px;\n  padding: 0 40px;\n  animation: stageEntry 1.8s cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n/* Primary Headlines */\n.primary-text {\n  font-family: 'Playfair Display', serif;\n  font-size: clamp(2.5rem, 5vw, 4.5rem);\n  font-weight: 500;\n  color: #ffffff;\n  line-height: 1.1;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.02em;\n  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);\n  animation: primarySlide 1.6s cubic-bezier(0.19, 1, 0.22, 1) 0.3s both;\n}\n\n/* Secondary Headlines */\n.secondary-text {\n  font-family: 'Playfair Display', serif;\n  font-size: clamp(1.8rem, 3.5vw, 3rem);\n  font-weight: 400;\n  font-style: italic;\n  color: #d4af37;\n  line-height: 1.2;\n  margin-bottom: 2rem;\n  letter-spacing: 0.01em;\n  text-shadow: 0 2px 15px rgba(212, 175, 55, 0.4);\n  animation: secondarySlide 1.6s cubic-bezier(0.19, 1, 0.22, 1) 0.6s both;\n}\n\n/* Elegant accent line */\n.accent-line {\n  width: 120px;\n  height: 2px;\n  background: linear-gradient(90deg,\n    transparent 0%,\n    #d4af37 20%,\n    #f4e4a6 50%,\n    #d4af37 80%,\n    transparent 100%\n  );\n  margin: 0 auto 2rem;\n  position: relative;\n  animation: lineExpand 2s cubic-bezier(0.19, 1, 0.22, 1) 0.9s both;\n}\n\n.accent-line::before {\n  content: '';\n  position: absolute;\n  top: -1px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 4px;\n  height: 4px;\n  background: #f4e4a6;\n  border-radius: 50%;\n  box-shadow: 0 0 10px rgba(244, 228, 166, 0.8);\n}\n\n/* Subtitle text */\n.subtitle {\n  font-family: 'Inter', sans-serif;\n  font-size: clamp(0.9rem, 1.5vw, 1.1rem);\n  font-weight: 300;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  margin-bottom: 1rem;\n  animation: subtitleFade 1.6s cubic-bezier(0.19, 1, 0.22, 1) 1.2s both;\n}\n\n/* Call to Action for final stage */\n.vision-cta {\n  margin-top: 3rem;\n  position: relative;\n  animation: ctaReveal 2s cubic-bezier(0.19, 1, 0.22, 1) 1.5s both;\n}\n\n.cta-text {\n  font-family: 'Inter', sans-serif;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #d4af37;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  display: inline-block;\n  padding: 12px 24px;\n  border: 1px solid rgba(212, 175, 55, 0.3);\n  backdrop-filter: blur(10px);\n  border-radius: 2px;\n  position: relative;\n  overflow: hidden;\n}\n\n.cta-text::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg,\n    transparent,\n    rgba(212, 175, 55, 0.1),\n    transparent\n  );\n  animation: shimmer 3s ease-in-out infinite 2s;\n}\n\n.diamond-sparkle {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  width: 8px;\n  height: 8px;\n  background: #f4e4a6;\n  transform: rotate(45deg);\n  animation: sparkle 2s ease-in-out infinite;\n}\n\n/* Floating Particles System */\n.diamond-particles {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.particle {\n  position: absolute;\n  width: 3px;\n  height: 3px;\n  background: radial-gradient(circle, #f4e4a6 0%, transparent 70%);\n  border-radius: 50%;\n  opacity: 0;\n  left: var(--x);\n  top: var(--y);\n  animation: particleFloat var(--duration) ease-in-out infinite var(--delay);\n}\n\n/* ========================================\n   LUXURY ANIMATIONS\n   ======================================== */\n\n@keyframes textReveal {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -40%);\n  }\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%);\n  }\n}\n\n@keyframes stageEntry {\n  from {\n    opacity: 0;\n    transform: translateY(60px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes primarySlide {\n  from {\n    opacity: 0;\n    transform: translateY(40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes secondarySlide {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes lineExpand {\n  from {\n    width: 0;\n    opacity: 0;\n  }\n  to {\n    width: 120px;\n    opacity: 1;\n  }\n}\n\n@keyframes subtitleFade {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 0.8;\n    transform: translateY(0);\n  }\n}\n\n@keyframes ctaReveal {\n  from {\n    opacity: 0;\n    transform: translateY(30px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes shimmer {\n  0% { left: -100%; }\n  100% { left: 100%; }\n}\n\n@keyframes sparkle {\n  0%, 100% {\n    opacity: 0.3;\n    transform: rotate(45deg) scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: rotate(45deg) scale(1.2);\n  }\n}\n\n@keyframes particleFloat {\n  0% {\n    opacity: 0;\n    transform: translateY(0px) scale(0.5);\n  }\n  10% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-100px) scale(1);\n  }\n}\n\n\n\n/* ========================================\n   RESPONSIVE LUXURY DESIGN\n   ======================================== */\n\n@media (max-width: 768px) {\n  .text-stage {\n    padding: 0 20px;\n  }\n\n  .primary-text {\n    font-size: clamp(1.8rem, 6vw, 3rem);\n  }\n\n  .secondary-text {\n    font-size: clamp(1.2rem, 4vw, 2rem);\n  }\n\n  .subtitle {\n    font-size: clamp(0.7rem, 2vw, 0.9rem);\n  }\n\n  .accent-line {\n    width: 80px;\n  }\n\n  .vision-cta {\n    margin-top: 2rem;\n  }\n\n  .cta-text {\n    font-size: 0.7rem;\n    padding: 10px 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .vision-text {\n    padding: 0 16px;\n  }\n\n  .text-stage {\n    padding: 0 16px;\n  }\n\n  .primary-text {\n    line-height: 1.2;\n    margin-bottom: 0.8rem;\n  }\n\n  .secondary-text {\n    margin-bottom: 1.5rem;\n  }\n\n  .accent-line {\n    width: 60px;\n    margin-bottom: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
